<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h5 class="info-text">Selecciona el producto</h5>
    </div>
    <div class="md-layout-item md-size-95 ml-auto mt-4 md-small-size-100 table-container">
      <table class="producto-table">
        <thead>
          <tr class="producto-table-header">
            <th v-on:click="selectAllProduct()" style="width:5%">
              <div class="md-table-head-label">
                <md-checkbox
                  v-model="all_selected"
                  class="checkbox-table"
                  @change="selectAllProduct"
                ></md-checkbox>
              </div>
            </th>
            <th style="width:40%">
              <div class="md-table-head-label">Producto</div>
            </th>
            <th style="width:15%">
              <div class="md-table-head-label">Albarán</div>
            </th>
            <th style="width:20%; text-align: center;">
              <div class="md-table-head-label">Und. Logistica</div>
            </th>
            <th style="width:20%; text-align: center;">
              <div class="md-table-head-label">Contenido</div>
            </th>
          </tr>
        </thead>
      </table>
      <!-- <div class="table-fixed"> -->
      <table class="producto-table" :key="product_table">
        <tbody>
          <tr v-for="(item, i) in issue.productos" :key="i" v-on:click="selectProduct(item)">
            <td style="width:5%">
              <md-checkbox
                v-model="item.selected"
                class="checkbox-table"
                @change="selectProductFromCheck(i)"
              ></md-checkbox>
            </td>
            <td style="width:40%">
              {{ item.producto.codigo }}
              <br />
              <small>{{ item.producto.descripcion_corta }}</small>
            </td>
            <td style="width:15%">{{item.codigoAlbaran}}</td>
            <td style="width:10%; text-align: right;">{{ item.cajas }}</td>
            <td style="width:10%">{{ item.producto.unidad }}</td>
            <td style="width:10%; text-align: right;">{{ item.cantidad }}</td>
            <td style="width:10%">{{ item.producto.contenido.unidad }}</td>
          </tr>
        </tbody>
      </table>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    issue: {
      type: Object,
    },
  },
  data() {
    return {
      selected: [],
      componentKey: 0,
      product_table: 0,
      all_selected: false,
      loaded: false,
      timer: "",
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.issue.selectedProductos = [];
      for (let index = 0; index < this.issue.productos.length; index++) {
        const element = this.issue.productos[index];
        if (element.selected) {
          element.cantidad_afectadas = element.cantidad;
          element.incidencia = {
            tipo: "",
            subtipos: [],
            selected_subtipo: "",
          };
          this.issue.selectedProductos.push(element);
        }
      }

      return this.$validator.validateAll().then((res) => {
        res = res && this.issue.selectedProductos.length > 0;
        return res;
      });
    },
    onSelect(items) {
      this.issue.selectedProductos = items;

      for (
        let index = 0;
        index < this.issue.selectedProductos.length;
        index++
      ) {
        const element = this.issue.selectedProductos[index];
        element.cantidad_afectadas = element.cantidad;
        element.incidencia = {
          tipo: "",
          subtipos: [],
          selected_subtipo: "",
        };
      }
    },
    forceRerender() {
      this.loaded = true;
      clearInterval(this.timer);
      window.dispatchEvent(new Event("resize"));
    },
    selectProduct(item) {
      item.selected = !item.selected;
      this.product_table++;
    },
    selectProductFromCheck() {
      this.product_table++;
    },
    selectAllProduct(value) {
      this.all_selected = value;
      for (let index = 0; index < this.issue.productos.length; index++) {
        const element = this.issue.productos[index];
        element.selected = value;
      }
    },
  },
  computed: {},
  watch: {},
  mounted() {
    this.loaded = false;
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  overflow: auto;
}
.producto-table {
  width: 100%;
  border-spacing: 0;
  min-width: 458px;
}
.producto-table tr {
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: background-color, font-weight;
  will-change: background-color, font-weight;
  line-height: 1.75em;
  cursor: pointer;
}
.producto-table td {
  border-top: 1px solid rgb(221, 221, 221);
  color: rgba(0, 0, 0, 0.87);
  padding: 12px 8px;
  font-size: 14px;
  line-height: 18px;
}
.producto-table i {
  font-size: 20px;
  color: #acacac;
}

.producto-table-header th {
  color: rgb(51, 51, 51);
  font-size: 700;
  padding: 12px 8px;
  text-align: left;
}
.checkbox-table {
  margin: 0px;
  font-size: 14px;
}

.table-fixed {
  max-height: 500px;
  overflow: auto;
}
.img-product {
  width: 90px;
  height: 90px;
}
.img-product > img {
  width: 100%;
  height: 100%;
}
</style>
